<template>
  <div class="container mt-30">
    <div class="row">
      <div class="col-lg-2 col-1"></div>
      <div class="col-lg-8 col-10">
        <div class="row">
          <div class="col-lg-12">
            <p  align="center"
          >
              <strong><span></span></strong></p>
            <p  align="center">
              <strong><span>
                           </span></strong></p>
            <p  align="center">
              <strong><span >ÍNDICE</span></strong>
            </p>
            <p >
              <strong><span></span></strong></p>
            <p 
>
              <strong><span >I. RESPONSABLE.</span></strong>
            </p>
            <p >
              <strong><span></span></strong></p>
            <p 
              >
              <strong><span >II. SIGNIFICADOS Y TÉRMINOS.</span></strong>
            </p>
            <p 
              >
              <strong><span
                            ></span></strong></p>
            <p 
              >
              <strong><span >III. FINALIDADES.</span></strong>
            </p>
            <p 
              >
              <strong><span
                            ></span></strong></p>
            <p 
              >
              <strong><span >IV. LIMITAR EL USO O DIVULGACIÓN DE SUS DATOS PERSONALES.</span></strong>
            </p>
            <p 
              >
              <strong><span
                            ></span></strong></p>
            <p 
              >
              <strong><span >V. PROTECCIÓN DE DATOS Y DERECHOS A.R.C.O.</span></strong>
            </p>
            <p 
              >
              <strong><span
                            ></span></strong></p>
            <p 
              >
              <strong><span >VI. TRANSFERENCIA DE DATOS.</span></strong>
            </p>
            <p 
              >
              <strong><span
                            ></span></strong></p>
            <p 
              >
              <strong><span >VII. ACTUALIZACIÓN DEL AVISO DE PRIVACIDAD.</span></strong>
            </p>
            <p 
              >
              <strong><span
                            ></span></strong></p>
            <p 
              >
              <strong><span >VIII. COOKIES. </span></strong>
            </p>
            <p 
              >
              <strong><span
                            ></span></strong></p>
            <p 
              >
              <strong><span >IX. MEDIDAS DE SEGURIDAD Y CONTROL PARA LA PROTECCIÓN DE SUS DATOS PERSONALES.</span></strong>
            </p>
            <p 
              >
              <strong><span
                           ></span></strong>
            </p>
            <p  align="center"
               >
              <strong><span  ></span></strong>
            </p>
            <p  align="center"
               >
              <strong><span  ></span></strong>
            </p>
            <p  align="center"
               >
              <strong><span  ></span></strong>
            </p>
            <p  align="center"
               >
              <strong><span  ></span></strong>
            </p>
            <p  align="center"
               >
              <strong><span  ></span></strong>
            </p>
            <p  align="center"
               >
              <strong><span  ></span></strong>
            </p>
            <p  align="center"
               >
              <strong><span  ></span></strong>
            </p>
            <p  align="center"
               >
              <strong><span  ></span></strong>
            </p>
            <p  align="center"
               >
              <strong><span  ></span></strong>
            </p>
            <p  align="center"
               >
              <strong><span  ></span></strong>
            </p>
            <p  align="center"
               >
              <strong><span  >AVISO DE PRIVACIDAD</span></strong>
            </p>
            <p  align="center"
               >
              <span  ></span></p>
            <p 
              >
              <strong><span  >I. RESPONSABLE.</span></strong>
            </p>
            <p 
              >
              <strong><span 
                            >CHUSPIC, S.A.P.I. DE C.V.</span></strong><span
                 > la cual<strong> </strong>tiene su domicilio ubicado en<strong> </strong></span><strong><span
                >Av. México Número Ext. #3300, Local D5-A, Colonia Monraz, Guadalajara, Jalisco</span></strong><strong><span
                 >, México, C.P. 44670 </span></strong><span
                 >y por medio del presente instrumento jurídico </span><span
                 >estipula rigurosamente su privacidad. El presente <u>AVISO DE PRIVACIDAD</u> explica las políticas de </span><strong><span
                
                >CHUSPIC, S.A.P.I. DE C.V.</span></strong><span
                 > </span><span 
                                                                                                 >o del sistema con respecto a la protección, recopilación, uso y divulgación de datos e </span><span
                >información que se adquiere a través del sitio web </span><span
                ><a href="http://www.chuspic.com" ><span
                                                                                         >www.chuspic.com</span></a></span><span
                >, de la aplicación descargable denominada <strong>CHUSPIC</strong>, llamadas telefónicas</span><span
                > </span><span 
                                                                                                      >y en sus instalaciones. Asimismo, describe los datos o el tipo de información que procesamos cuando <strong>“EL USUARIO”</strong> requiere de los servicios y productos de </span><strong><span
                
                >CHUSPIC, S.A.P.I. DE C.V.</span></strong><span
                 > Este último,</span><span 
                                                                                                             > en cumplimiento con la Ley Federal de Protección de Datos Personales en Posesión de Particulares y su Reglamento, hace de su conocimiento que la misma es responsable de recabar sus datos personales, del uso que se les dé a los mismo y de su protección, con la finalidad de evitar el tratamiento no autorizado, así como cualquier tipo de alteración, destrucción o daño de sus datos personales.<strong></strong></span>
            </p>
            <p 
              >
              <strong><span  >II.- <u>SIGNIFICADOS Y TÉRMINOS</u></span></strong>
            </p>
            <p 
              >
              <strong><span  >1.- “EL USUARIO”: </span></strong><span
                 >Se refiere a la persona física que accede, se registra y usa el sitio web </span><span
                ><a href="http://www.chuspic.com" ><span 
                                                                                         >www.chuspic.com </span></a></span><span
                 > y/o la aplicación descargable titulada <strong>CHUSPIC</strong><span
                ><span
               > y/o solicita, adquiere y/o compra los servicios y productos publicados por </span></span><strong>CHUSPIC, S.A.P.I. DE C.V<span
                ><span
               >.</span></span></strong></span></p>
            <p 
              >
              <strong><span 
                            >2.- “Datos personales”:</span></strong><span
                 > Se refiere<strong> </strong>a cualquier información de cualquier tipo relacionada con una persona física que pueda identificarla, directa o indirectamente, en particular por referencia a dichos datos.</span>
            </p>
            <p 
              >
              <strong><span 
                            >3.- “Información”: </span></strong><span
                
                >Se refiere<strong> </strong></span><span
                
                >al conjunto organizado d</span><span
                
                >e</span><span
                ><a href="https://es.wikipedia.org/wiki/Datos" title="Datos" ><span
                
                >datos</span></a></span><span
                
                >procesados, que </span><strong><span
                
                >CHUSPIC, S.A.P.I. DE C.V.</span></strong><span
                 > </span><span 
                                                                                                 >obtiene </span><span
                 >de <strong>“EL USUARIO”</strong> cuando visita el sitios web </span><span
                ><a href="http://www.chuspic.com" ><span 
                                                                                         >www.chuspic.com</span></a></span><span
                 >, la aplicación descargable titulada <strong>CHUSPIC</strong></span><span
                
                >, compra, uso o requerimiento de los servicios y/o productos.</span>
            </p>
            <p 
              >
              <span 
                    ></span>
            </p>
            <p 
              >
              <strong><span  >III. DATOS OBTENIDOS.</span></strong>
            </p>
            <p 
              >
              <span 
                    >Cuando <strong>“EL USUARIO”,</strong> visita el sitio web </span><span
                ><a href="http://www.chuspic.com" ><span 
                                                                                         >www.chuspic.com</span></a></span><span
                 >, la aplicación descargable titulada <strong>CHUSPIC</strong> o recibe los servicios y/o productos que ofrece <strong>CHUSPIC, S.A.P.I. DE C.V.</strong>, a través del sitio web, aplicación descargable, llamadas telefónicas o en las instalaciones de <strong>CHUSPIC, S.A.P.I. DE C.V.</strong> Esta última implementa un procesamiento de datos personales.</span>
            </p>
            <p 
              >
              <span  ></span></p>
            <p 
              >
              <span  >Los datos personales que <strong>“EL USUARIO” </strong>proporcione a </span><strong><span
                
                >CHUSPIC, S.A.P.I. DE C.V.</span></strong><span
                 > </span><span 
                                                                                                 >a través de sus oficinas, llamadas telefónicas, correos electrónicos corporativos, sitio web </span><span
                ><a href="http://www.chuspic.com" ><span 
                                                                                         >www.chuspic.com</span></a></span><span
                
                >, aplicación descargable titulada <strong>CHUSPIC</strong> o mediante el llenado de formularios físicos o electrónicos; <strong>CHUSPIC, S.A.P.I. DE C.V. </strong>cumple con todos los requisitos y principios que la Ley Federal de Protección de Datos Personales en Posesión de los Particulares y su respectivo reglamento estipulan.</span>
            </p>
            <p 
              >
              <span  ></span></p>
            <p 
              >
              <span  >Los datos que <strong>CHUSPIC, S.A.P.I. DE C.V. </strong>recopila y obtiene son los siguientes:</span>
            </p>
            <p 
               >
              <span >Ø<span
                 > </span></span><span
               
             >Datos de identificación (Usuario, clientes, empleados, proveedores, etc.).</span>
            </p>
            <p 
               >
              <span >·<span
                 > </span></span><span
               
             >Nombre completo (nombre(s), apellido paterno, apellido materno), sexo, estado civil, fecha de nacimiento, ocupación.</span>
            </p>
            <p 
               >
              <span >·<span
                 > </span></span><span
               
             >Dirección (calle, número, colonia, municipio, estado y código postal).</span>
            </p>
            <p 
               >
              <span >·<span
                 > </span></span><span
               
             >Teléfonos de contacto (móvil, casa, oficina).</span>
            </p>
            <p 
               >
              <span >·<span
                 > </span></span><span
               
             >Comprobante de domicilio.</span>
            </p>
            <p 
               >
              <span >·<span
                 > </span></span><span
               
             >Correo electrónico.</span>
            </p>
            <p 
               >
              <span >·<span
                 > </span></span><span
               
             >Documento de identificación (INE, PASAPORTE, LICENCIA, CARTILLA O CÉDULA PROFESIONAL).</span>
            </p>
            <p 
               >
              <span >·<span
                 > </span></span><span
               
             >Acta Constitutiva y Poder del Representante Legal.</span>
            </p>
            <p 
               >
              <span >·<span
                 > </span></span><span
               
             >Acta de Nacimiento.</span>
            </p>
            <p 
               >
              <span >·<span
                 > </span></span><span
               
             >Currículum Vitae.</span>
            </p>
            <p 
               >
              <span >Ø<span
                 > </span></span><span
               
             >Datos de Facturación.</span>
            </p>
            <p 
               >
              <span >·<span
                 > </span></span><span
               
             >Entidad en la que se hará el cargo.</span>
            </p>
            <p 
               >
              <span >·<span
                 > </span></span><span
               
             >Domicilio fiscal.</span>
            </p>
            <p 
               >
              <span >·<span
                 > </span></span><span
               
             >R.F.C.</span>
            </p>
            <p 
               >
              <span >Ø<span
                 > </span></span><span
               
             >Datos financieros.</span>
            </p>
            <p 
              >
              <span >·<span
                 > </span></span><span
               
             >Forma de pago.</span>
            </p>
            <p 
              >
              <span >·<span
                 > </span></span><span
               
             >Titular, número de cuenta, número de tarjeta y CLABE.</span>
            </p>
            <p 
              >
              <span >·<span
                 > </span></span><span
               
             >Estados de Cuenta.</span>
            </p>
            <p 
               >
              <span >Ø<span
                 > </span></span><span
               
             >Datos Contables.</span>
            </p>
            <p 
              >
              <span >·<span
                 > </span></span><span
               
             >Constancia de cumplimiento fiscal.</span>
            </p>
            <p 
              >
              <span >·<span
                 > </span></span><span
               
             >Cotización y Facturación.</span>
            </p>
            <p 
              >
              <span  ></span></p>
            <p 
              >
              <strong><span
                         >CHUSPIC, S.A.P.I. DE C.V.</span></strong><span
               
             >, solicita los siguientes datos considerados de carácter SENSIBLE para la contratación de su personal:</span>
            </p>
            <p 
               >
              <span >·<span
                 > </span></span><span
               
             >Estudios socioeconómicos.</span>
            </p>
            <p 
               >
              <span >·<span
                 > </span></span><span
               
             >Constancia de Antecedentes No Penales.</span>
            </p>
            <p 
               >
              <span
                 ></span>
            </p>
            <p 
              >
              <span
                 >Para la obtención de los datos anteriormente señalados, <strong>CHUSPIC, S.A.P.I. DE C.V.</strong>, obtiene el consentimiento expreso del titular, tal y como lo establece el artículo 9º de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares.</span>
            </p>
            <p 
               >
              <span 
                    >Si no proporciona estos datos, <strong>CHUSPIC, S.A.P.I. DE C.V.</strong> no podrá atender ni responder a su solicitud, prestar sus servicios o entregar sus productos.</span>
            </p>
            <p 
              >
              <span  >Adicionalmente recopilamos información necesaria para verificar y confirmar su identidad, con la finalidad de prestar los servicios y poderle entregar los productos, solicitados a través de correos electrónicos corporativos, sitio web </span><span
                ><a href="http://www.chuspic.com" ><span 
                                                                                         >www.chuspic.com</span></a></span><span
                 >, la aplicación descargable titulada <strong>CHUSPIC</strong>, llamadas telefónicas, así como cumplir con las obligaciones contractuales.</span>
            </p>
            <p 
              >
              <span  ></span></p>
            <p 
              >
              <span  >De igual manera, el tratamiento de datos personales de terceros que <strong>“EL USUARIO”</strong> proporcione a <strong>CHUSPIC, S.A.P.I. DE C.V. </strong>, se hace de conformidad con los términos y condiciones estipulados en el presente <u>AVISO DE PRIVACIDAD</u>. Por lo antes mencionado, <strong>“EL USUARIO” </strong>expresa su consentimiento para el tratamiento de sus datos personales de acuerdo a los términos y condiciones de este aviso de privacidad.</span>
            </p>
            <p 
              >
              <span  ></span></p>
            <p 
              >
              <strong><span  >III. FINALIDADES.</span></strong>
            </p>
            <p 
              >
              <span  >Sus datos personales serán destinados para las siguientes finalidades primarias y secundarias:</span>
            </p>
            <p 
              >
              <em><u><span  ></span></u></em></p>
            <p 
              >
              <em><u><span 
                           >Finalidades primarias</span></u></em><span
                 ></span></p>
            <p 
              >
              <span  >Los datos personales serán destinados para: <strong>(i)</strong> fines de prestar los servicios y proveer los productos solicitados; <strong>(ii)</strong> responder a sus requerimientos de información, atención y servicio; <strong>(iii)</strong> evaluar la calidad de los productos o servicios que le brindamos; <strong>(iv)</strong> base de datos y expedientes; <strong>(v)</strong> gestión financiera, facturación y cobro; <strong>(vi)</strong> dar cumplimiento a las obligaciones y compromisos que hemos contraído con <strong>“EL USUARIO”</strong>, clientes, empleados, proveedores, etc.; <strong>(vii)</strong> Para evitar fraudes y spam, hacer cumplir la ley; <strong>(viii)</strong> notificar las modificaciones a las políticas de privacidad; <strong>(ix)</strong> </span><span
                >contactar con <strong>“EL USUARIO”</strong> o cliente por cualquier inconveniente referente al pago que haya realizado con tarjeta (VISA, MasterCard, American Express, PayPal, entre otras</span><span
                 >; y <strong>(x)</strong> </span><span
                >la información que se obtiene por medio del sitio web con dominio </span><span
                ><a href="http://www.chuspic.com" ><span
                                                                                         >www.chuspic.com</span></a></span><span
                >, la aplicación descargable titulada <strong>CHUSPIC</strong> o correos corporativos para fines estadísticos y de mercadotecnia con el propósito de brindarle una mejor calidad en los productos y servicios</span><span
               
             >.</span><span
                
                > Realmente queremos que el sitio web </span><span
                ><a href="http://www.chuspic.com" ><span 
                                                                                         >www.chuspic.com</span></a></span><span
                 > esté libres de spam y contenido fraudulento para que se sienta seguro y libre. Podemos usar su información para prevenir, detectar e investigar fraudes, violaciones de seguridad, actividades potencialmente prohibidas o ilegales, proteger las marcas registradas propiedad de <strong>CHUSPIC, S.A.P.I. DE C.V. </strong>y hacer cumplir los Términos de uso.</span><strong><span
                ></span></strong></p>
            <p 
              >
              <strong><span  ></span></strong>
            </p>
            <p 
              >
              <span  >Si surgen nuevos propósitos para procesar sus datos personales, le informaremos que comenzamos a procesar información sobre ese otro propósito mediante la introducción de los cambios correspondientes a este <u>AVISO DE PRIVACIDAD</u>.<span
                 ></span></span></p>
            <p 
              >
              <em><u><span  ></span></u></em></p>
            <p 
              >
              <em><u><span 
                           >Finalidades secundarias</span></u></em><span
                 ></span></p>
            <p 
              >
              <span  >Los datos personales serán destinados para: <strong>(i)</strong> Envío de información de nuevos productos y servicios; <strong>(ii)</strong> envío de promociones de los productos y servicios; <strong>(iii)</strong> envío de publicidad de los productos y servicios.</span>
            </p>
            <p 
              >
              <span  ></span></p>
            <p 
              >
              <span  >De manera adicional, utilizaremos su información personal para las siguientes finalidades que no son necesarias para el servicio solicitado, pero que permite y facilita a <strong>CHUSPIC, S.A.P.I. DE C.V. </strong>a brindarle una mejor atención:</span>
            </p>
            <p 
              >
              <span  ></span></p>
            <p 
              >
              <span  >Como oír y recibir notificaciones en caso de que requiera ejercer los derechos de Acceso, Rectificación, Cancelación u Oposición, por sus siglas <strong>“A.R.C.O.”</strong>, trámite que se describe posteriormente.</span>
            </p>
            <p 
              >
              <span  ></span></p>
            <p 
              >
              <strong><span  >IV. LIMITACIÓN DE USO O DIVULGACIÓN DE SUS DATOS PERSONALES.</span></strong>
            </p>
            <p 
              >
              <span  >Para el caso de que deseé que sus datos personales no se utilicen desde este momento para los fines descritos en el apartado de <u>FINALIDADES SECUNDARIAS</u>, <strong>“EL USUARIO”</strong> o cliente podrá enviar un correo electrónico a la dirección: </span><span
                ><a href="mailto:contacto@chuspic.com" ><span 
                                                                                              >contacto@chuspic.com</span></a></span><span
                 >, </span><span ><a
                href="mailto:info@jefferson-school.edu.mx" ></a></span><span 
                                                                                                 ></span><span
                 >solicitando el NO consentimiento de utilización y tratamiento de sus datos personales para la totalidad o algunas finalidades secundarias descritas en este <u>AVISO DE PRIVACIDAD</u>. <strong>CHUSPIC, S.A.P.I. DE C.V. </strong>a la brevedad posible atenderá a su solicitud y dejará de utilizar o tratar sus datos personales para las finalidades secundarias que señale.</span>
            </p>
            <p 
              >
              <strong><span  ></span></strong>
            </p>
            <p 
              >
              <strong><span  >V. PROTECCIÓN DE DATOS Y DERECHOS A.R.C.O.</span></strong>
            </p>
            <p 
              >
              <strong><span 
                            >“EL USUARIO” </span></strong><span
                 >o cliente tiene el derecho de acceder a sus datos personales que poseemos y a los detalles del tratamiento de los mismos, así como a rectificarlos en caso de ser inexactos o incompletos; cancelarlos cuando considere que no se requieren para alguna de las finalidades señaladas en el presente <u>AVISO DE PRIVACIDAD</u>; estén siendo utilizados para finalidades no consentidas; haya finalizado la relación contractual o de servicio; oponerse al tratamiento de los mismos para fines específicos. El hecho de ejercer el derecho de oposición NO implica que se deje recibir productos por parte de </span><strong><span
                
                >CHUSPIC, S.A.P.I. DE C.V.</span></strong><span
                 ></span></p>
            <p 
              >
              <span  ></span></p>
            <p 
              >
              <span  >Los mecanismos que se han implementado para el ejercicio de dichos derechos, son a través del envió de la solicitud respectiva al correo electrónico: </span><span
                ><a href="mailto:contacto@chuspic.com" ><span 
                                                                                              >contacto@chuspic.com</span></a></span><span
                >; </span><span  >Dicha solicitud podrá solicitarla vía electrónica, o bien, en alguna de las oficinas de </span><strong><span
                
                >CHUSPIC, S.A.P.I. DE C.V.</span></strong><span
                 > </span><span 
                                                                                                 >El formato oficial de solicitud para ejercer sus derechos <strong>“A.R.C.O.” </strong>y que únicamente será aceptado, es el proporcionado por </span><strong><span
                
                >CHUSPIC, S.A.P.I. DE C.V.</span></strong><span
                 >,</span><span 
                                                                                                 > el cual deberá contener la siguiente información:</span><span
                
                ></span>
            </p>
            <p 
              >
              <span  ></span></p>
            <p 
               >
              <span  >1.<span
                 > </span></span><span
                 >El nombre del titular, domicilio y correo electrónico para comunicarle la respuesta a su solicitud.</span>
            </p>
            <p 
               >
              <span  >2.<span
                 > </span></span><span
                 >Indicar que derecho se pretende ejercer; Si es Acceso, Rectificación, Cancelación u Oposición.</span>
            </p>
            <p 
               >
              <span  >3.<span
                 > </span></span><span
                 >La descripción clara y precisa de los datos personales respecto de los que se busca ejercer alguno de los derechos.</span>
            </p>
            <p 
               >
              <span  >4.<span
                 > </span></span><span
                 >Copia de identificación oficial válida (credencial de elector, pasaporte, cartilla militar, cédula profesional) para acreditar su identidad como titular. En caso de que el trámite lo realice algún representante deberá exhibir carta poder firmada ante dos testigos con copia de la identificación oficial del titular de los datos.</span>
            </p>
            <p 
              >
              <span  ></span></p>
            <p 
              >
              <span >El plazo máximo de respuesta por parte de <strong>CHUSPIC, S.A.P.I. DE C.V.</strong> con la determinación adoptada de su solicitud será en un término de <u>veinte días hábiles</u> contados a partir de la fecha en que se recibió la solicitud de Acceso, Rectificación, Cancelación u Oposición <strong>“A.R.C.O.”</strong>.</span>
            </p>
            <p 
              >
              <span ></span></p>
            <p 
              >
              <span >En caso de resultar procedente su solicitud, a efecto de que se haga efectiva la misma, dentro de un plazo máximo de <u>quince días hábiles</u> contados a partir de la fecha en que se comunicó la respuesta de procedencia por parte de <strong>CHUSPIC, S.A.P.I. DE C.V.</strong>, a través del envió de un correo electrónico, podrá recibir su informe respectivo en el domicilio señalado al inicio de este <u>AVISO DE PRIVACIDAD</u>.</span>
            </p>
            <p 
              >
              <span ></span></p>
            <p 
              >
              <span >Cabe mencionar que tanto el ejercicio de los derechos <strong>“A.R.C.O.”</strong> y la revocación de consentimiento no tiene costo alguno, más que el que se derive de la reproducción de la información.</span>
            </p>
            <p 
              >
              <span ></span></p>
            <p 
              >
              <span >Así mismo, en todo momento, usted podrá revocar el consentimiento que ha otorgado a <strong>CHUSPIC, S.A.P.I. DE C.V.</strong> para el tratamiento de sus datos personales, a fin de dejar de hacer uso de los mismos. Para ello, es necesario que presente petición y documentos para acreditar personalidad, en los mismos términos que se establecen para el ejercicio de derechos de Acceso, Rectificación, Cancelación u Oposición <strong>“A.R.C.O.”</strong>.</span><span
               
             ></span>
            </p>
            <p 
              >
              <span
                 ></span>
            </p>
            <p 
              >
              <strong><span  >VI. TRANSFERENCIA DE DATOS.</span></strong>
            </p>
            <p 
              >
              <strong><span  >CHUSPIC, S.A.P.I. DE C.V. </span></strong><span
                 >puede compartir o transferir la información personal de <strong>“EL USUARIO”</strong>, cliente, empleados y proveedores con personas ajenas a <strong>CHUSPIC, S.A.P.I. DE C.V. </strong>, únicamente de la manera que se describe en este <u>AVISO DE PRIVACIDAD</u>. </span>
            </p>
            <p 
              >
              <span  ></span></p>
            <p 
               >
              <span  >A.<span
                 > </span></span><span
                 >Podemos compartir su información personal con los socios comerciales, proveedores y consultores externos que realizan servicios en nombre de <strong>CHUSPIC, S.A.P.I. DE C.V. </strong>o que ayudan a proporcionar los productos, como servicios contables, administrativos, técnicos, de marketing o analíticos.</span>
            </p>
            <p 
               >
              <span  >B.<span
                 > </span></span><span
                 >Cualquier información o contenido que el <strong>“USUARIO”</strong> publique voluntariamente en el sitio web </span><span
                ><a href="http://www.chuspic.com" ><span
                                                                                         >www.chuspic.com</span></a></span><span
                > y</span><span
                >/o la </span><span 
                                                                                            >aplicación descargable titulada <strong>CHUSPIC,</strong></span><span
                 > </span><span 
                                                                                                 >estará consiente que dicha información corre el riesgo de ser filtrada, publicada o ser conocida por terceros ajenos, por lo que <strong>“EL USUARIO” </strong>deslinda de responsabilidad alguna a </span><strong><span
                
                >CHUSPIC, S.A.P.I. DE C.V.</span></strong><strong><span
                 >,</span></strong><span 
                                                                                                          > si su información fue robada o filtrada por persona ajena a </span><strong><span
                
                >CHUSPIC, S.A.P.I. DE C.V. </span></strong><span
                 >o a <strong>“EL USUARIO”.</strong></span>
            </p>
            <p 
               >
              <span  >C.<span
                 > </span></span><span
                 >Podemos publicar sus comentarios en el sitio web</span><span
                > </span><span ><a href="http://www.chuspic.com" ><span
               
                >www.chuspic.com</span></a></span><span
                >, </span><span 
                                                                                        >aplicación descargable titulada <strong>CHUSPIC</strong>, o redes sociales o vincular sus comentarios a sitios web de terceros.</span>
            </p>
            <p 
               >
              <span  >D.<span
                 > </span></span><span
                
                >En cualquier momento </span><strong><span
                
                >CHUSPIC, S.A.P.I. DE C.V. </span></strong><span
                 >podrá vender la marca, la empresa y/o porcentaje de ésta. La información personal, como los nombres de los clientes y/o usuarios y las direcciones de correo electrónico, y otra información de <strong>“EL USUARIO”</strong>, probablemente sea uno de los elementos transferidos en este tipo de transacciones. También podemos compartir, transferir o asignar dicha información en el curso de desinversiones corporativas, fusiones, adquisiciones, quiebras, disoluciones o transacciones o procedimientos similares.</span>
            </p>
            <p 
               >
              <span  >E.<span
                 > </span></span><span
                 >Excepto como se describió anteriormente, <strong>CHUSPIC, S.A.P.I. DE C.V.</strong> no divulgará información personal a terceros (incluidas las fuerzas del orden público, otra entidad gubernamental o litigante civil; excluyendo a subcontratistas de <strong>CHUSPIC, S.A.P.I. DE C.V. </strong>), salvo que así lo exija la ley o citación, a exclusivo criterio sea necesario para <strong>(a)</strong> cumplir con la ley, cumplir con el proceso legal o investigar, prevenir o tomar medidas con respecto a actividades ilegales sospechosas o reales; <strong>(b)</strong> para hacer cumplir los Términos y Condiciones de uso, tomar precauciones contra la responsabilidad, investigar y defendernos de cualquier reclamo o denuncia, o para proteger la seguridad o integridad del sitio web </span><span
                ><a href="http://www.chuspic.com" ><span 
                                                                                         >www.chuspic.com </span></a></span><span
                 > y la aplicación descargable titulada <strong>CHUSPIC</strong>; y/o <strong>(c)</strong> para ejercer o proteger los derechos, la propiedad o la seguridad personal de <strong>CHUSPIC, S.A.P.I. DE C.V. ,</strong> Usuarios u otros.</span>
            </p>
            <p 
              >
              <span  ></span></p>
            <p 
              >
              <strong><span  >VII. ACTUALIZACIÓN DEL AVISO DE PRIVACIDAD.</span></strong>
            </p>
            <p 
              >
              <strong><span 
                            >CHUSPIC, S.A.P.I. DE C.V. </span></strong><span
                 >se reserva el derecho de efectuar en cualquier momento modificaciones o actualizaciones al presente <u>AVISO DE PRIVACIDAD</u>, para la atención de novedades legislativas, políticas internas o nuevos requerimientos para la prestación u ofrecimiento de servicios o productos. Estas modificaciones estarán disponibles al público a través de los siguientes medios: anuncio visible en las oficinas de </span><strong><span
                
                >CHUSPIC, S.A.P.I. DE C.V. </span></strong><span
                 >y/</span><span 
                                                                                                        >o bien en el sitio web </span><span
                ><a href="http://www.chuspic.com" ><span
                                                                                         >www.chuspic.com </span></a></span><span
                > </span><span
                >y/o en la </span><span 
                                                                                                >aplicación descargable titulada <strong>CHUSPIC</strong>.</span><span
                ></span></p>
            <p 
              >
              <strong><span  ></span></strong>
            </p>
            <p 
              >
              <strong><span >VIII. COOKIES.</span></strong>
            </p>
            <p 
              >
              <span >De igual manera le informamos que se obtiene por medio del </span><span
                 >sitio web </span><span
                ><a href="http://www.chuspic.com" ><span
                                                                                         >www.chuspic.com </span></a></span><span
                > </span><span
                >y/o de la </span><span 
                                                                                                >aplicación descargable titulada <strong>CHUSPIC</strong></span><span
               
                >,la dirección IP,<em>cookies</em>, web beacons y otras tecnologías a través de las cuales es posible monitorear su comportamiento como <strong>USUARIO</strong> de Internet, así como brindarle un mejor servicio y experiencia de usuario al navegar en la página y aplicación descargable de </span><strong><span
                
                >CHUSPIC, S.A.P.I. DE C.V. </span></strong><span
                ></span></p>
            <p 
              >
              <span  ></span></p>
            <p 
              >
              <span 
                    >Las finalidades por las cuales <strong>CHUSPIC, S.A.P.I. DE C.V.</strong> utilizará los cookies de sesión y permanentes son:</span>
            </p>
            <ul type="disc" >
              <li 
                  >
                <span  >Rastrear sus movimientos mientras navega en el sitio web </span><span
                  ><a href="http://www.chuspic.com" ><span
                                                                                           >www.chuspic.com</span></a></span><span
                  > </span><span
                  >y/</span><span 
                                                                                          >o de la aplicación descargable titulada <strong>CHUSPIC</strong>.</span>
              </li>
              <li 
                  >
                <span  >Prevenir fraude y aumentar la seguridad del sitio web </span><span
                  ><a href="http://www.chuspic.com" ><span
                                                                                           >www.chuspic.com </span></a></span><span
                  > </span><span
                  >y/o de la </span><span 
                                                                                                  >aplicación descargable titulada <strong>CHUSPIC</strong>.</span>
              </li>
              <li 
                  >
                <span  >Usaremos los cookies permanentes para permitir que el Sitio lo reconozca cuando lo visite y mantener registro de sus preferencias en relación a su uso del sitio con fines de mejorar los servicio a <strong>“EL USUARIO”</strong>, funcionalidades y promoción.</span>
              </li>
              <li 
                  >
                <span 
                      >Con la finalidad de que <strong>“EL USUARIO”</strong> no tenga que introducir su nombre de usuario ni su contraseña con frecuencia.</span>
              </li>
              <li 
                  >
                <span  >Para generar estadísticas de mercadotecnia.</span>
              </li>
              <li 
                  >
                <strong><span  >CHUSPIC, S.A.P.I. DE C.V. </span></strong><span
                   >se obliga a que el uso de las cookies siempre serán en beneficio de <strong>“EL USUARIO”</strong>.</span>
              </li>
            </ul>
            <p 
              >
              <span ></span></p>
            <p 
              >
              <span >Se estipula que la instalación, permanencia y existencia de las Cookies en el ordenador de <strong>“EL USUARIO”</strong> depende de su voluntad, toda vez que esta puede ser eliminada de su ordenador cuando <strong>“EL USUARIO”</strong> así lo desee.</span><span
                 ></span></p>
            <p 
              >
              <span  ></span></p>
            <p 
              >
              <strong><span 
                            >CHUSPIC, S.A.P.I. DE C.V. </span></strong><span
                 >cubre la utilización de cookies por </span><span
                 >el sitio web </span><span
                ><a href="http://www.chuspic.com" ><span
                                                                                         >www.chuspic.com </span></a></span><span
                > </span><span
                >y/o de la </span><span 
                                                                                                >aplicación descargable titulada <strong>CHUSPIC</strong>, pero no cubre la utilización de cookies por parte de algún tercero ajeno a <strong>CHUSPIC, S.A.P.I. DE C.V. .</strong></span>
            </p>
            <p 
              >
              <span  ></span></p>
            <p 
              >
              <strong><span  >IX. MEDIDAS DE SEGURIDAD Y CONTROL PARA LA PROTECCIÓN DE SUS DATOS PERSONALES.</span></strong>
            </p>
            <p 
              >
              <strong><span 
                            >CHUSPIC, S.A.P.I. DE C.V. </span></strong><strong><span
                 ></span></strong><span 
                                                                                                               >cuenta con medidas de seguridad para sus datos personales tales como: administrativas, técnicas y físicas, mismas que <strong>CHUSPIC, S.A.P.I. DE C.V. </strong>se cerciora que sean cumplidas por el personal de <strong>CHUSPIC, S.A.P.I. DE C.V.</strong></span>
            </p>
            <p 
              >
              <strong><span  ></span></strong>
            </p>
            <p 
              >
              <em><u><span
                        >Este documento fue modificado por última vez el día <strong>30 de julio de 2021</strong></span></u></em><span
               
             >.</span><span
                 ></span></p>
            <p 
              >
              <span ></span></p>

          </div>

        </div>
      </div>
      <div class="col-lg-2 col-1"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPoliciesChuspic",
}
</script>

<style scoped>
</style>
